<template>
    <div class="border-bottom mb-1 d-flex justify-content-between hover-title-bg" :class="'text-' + ( color ? color : 'primary' ) ">
        <div>
            <a href="#" @click.prevent="toggle_show_hide()" class="card-link mr-2" v-if="showhide && model">
                <i class="fa-regular fa-square-minus" v-if="!model.hide"></i>
                <i class="fa-regular fa-square-plus" v-else></i>
            </a>

            <a href="#" @click.prevent="scrolltop_action()" class="card-link" v-if="scrolltop" ref="linktop">
                <big v-if="big" :class="titleclass">{{ title }}</big>
                <small v-else :class="titleclass">{{ title }}</small>
            </a>
            <template v-else>
                <big v-if="big">{{ title }}</big>
                <small v-else>{{ title }}</small>
            </template>
        </div>
        <div :class="info_sm ? 'small' : ''">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    data () { 
        return {}
    },

    props: [ 'title', 'big', 'color', 'scrolltop', 'info_sm', 'showhide', 'model', 'titleclass' ],

    methods: {
        toggle_show_hide () { 
            this.model.hide = !this.model.hide;
        },

        scrolltop_action () {
            console.log(this.$refs.linktop);
            const posic = this.$refs.linktop.getBoundingClientRect().top + window.scrollY - 100;
            console.log(posic);
            window.scrollTo({ top: posic, behavior: 'smooth' });
            //this.$refs.linktop.scrollTo({ top: 300, behavior: 'smooth' });
            // this.$refs.linktop.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}
</script>

<style scoped>
.hover-title-bg:hover {
    filter: brightness(1);
    /*background-color: #f8f9fa;*/
}
</style>